"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
import type { SubstitutionData } from "./playerEventsHelper";
import { SubOutIcon, SubInIcon } from "@/components/ui/icons/PlayerEventIcons";
import { useMatchPageData } from "../../context/MatchPageDataContext";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
interface SubstitutionRowProps {
  substitution: SubstitutionData;
  /** If true, align content to the left; otherwise to the right */
  alignLeft?: boolean;
}

/**
 * Format minute display with optional injury time
 */
function formatMinute(minute: number, injuryMinute?: number): string {
  return injuryMinute ? `${minute}+${injuryMinute}'` : `${minute}'`;
}

/**
 * SubstitutionRow - Displays a single substitution with player out and player in
 * Shows minute, player out (with red icon), and player in (with green icon, bold)
 */
export const SubstitutionRow: React.FC<SubstitutionRowProps> = t0 => {
  const $ = _c(35);
  const {
    substitution,
    alignLeft: t1
  } = t0;
  const alignLeft = t1 === undefined ? true : t1;
  const {
    minute,
    injuryMinute,
    playerOut,
    playerIn
  } = substitution;
  const {
    playerIdMap
  } = useMatchPageData();
  const nav = useNavigation();
  let t2;
  if ($[0] !== nav || $[1] !== playerIdMap || $[2] !== playerOut.id) {
    t2 = playerIdMap[playerOut.id] ? nav.player(playerIdMap[playerOut.id]) : undefined;
    $[0] = nav;
    $[1] = playerIdMap;
    $[2] = playerOut.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const playerOutHref = t2;
  let t3;
  if ($[4] !== nav || $[5] !== playerIdMap || $[6] !== playerIn.id) {
    t3 = playerIdMap[playerIn.id] ? nav.player(playerIdMap[playerIn.id]) : undefined;
    $[4] = nav;
    $[5] = playerIdMap;
    $[6] = playerIn.id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const playerInHref = t3;
  const t4 = `flex items-start gap-2 py-1.5 ${alignLeft ? "" : "flex-row-reverse"}`;
  let t5;
  if ($[8] !== injuryMinute || $[9] !== minute) {
    t5 = formatMinute(minute, injuryMinute);
    $[8] = injuryMinute;
    $[9] = minute;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <span className="text-xs font-bold text-muted-foreground w-8 shrink-0 pt-0.5">{t5}</span>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = `flex flex-col gap-0.5 ${alignLeft ? "" : "items-end"}`;
  const t8 = `flex items-center gap-1.5 ${alignLeft ? "" : "flex-row-reverse"}`;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SubOutIcon className="shrink-0" />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== playerOut.name || $[15] !== playerOutHref) {
    t10 = playerOutHref ? <Link href={playerOutHref} prefetch={false} className="text-sm link-neutral hover:underline">{playerOut.name}</Link> : <span className="text-sm text-foreground/80">{playerOut.name}</span>;
    $[14] = playerOut.name;
    $[15] = playerOutHref;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t8) {
    t11 = <div className={t8}>{t9}{t10}</div>;
    $[17] = t10;
    $[18] = t8;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = `flex items-center gap-1.5 ${alignLeft ? "" : "flex-row-reverse"}`;
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SubInIcon className="shrink-0" />;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== playerIn.name || $[22] !== playerInHref) {
    t14 = playerInHref ? <Link href={playerInHref} prefetch={false} className="text-sm font-semibold link-neutral hover:underline">{playerIn.name}</Link> : <span className="text-sm font-semibold text-foreground">{playerIn.name}</span>;
    $[21] = playerIn.name;
    $[22] = playerInHref;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t12 || $[25] !== t14) {
    t15 = <div className={t12}>{t13}{t14}</div>;
    $[24] = t12;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t11 || $[28] !== t15 || $[29] !== t7) {
    t16 = <div className={t7}>{t11}{t15}</div>;
    $[27] = t11;
    $[28] = t15;
    $[29] = t7;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t16 || $[32] !== t4 || $[33] !== t6) {
    t17 = <div className={t4}>{t6}{t16}</div>;
    $[31] = t16;
    $[32] = t4;
    $[33] = t6;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
};